module.exports = __webpack_public_path__ + "img/footer_logo_hover.18dd992e.png";